import styled, { css } from 'styled-components';

export default {
  TimeframeWrapper: styled.p`
    margin-bottom: 5px;
    ${({ theme }) => css`
      color: ${theme.palette.dark.main};
      ${theme.breakpoints.up('sm')} {
        margin-bottom: 0;
      }
    `}
  `,
};
